import React from 'react'
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'

import AlternativeHealth from '../../static/Alternative_Health.png'
import Athletics from '../../static/Athletics.png'
import Awards from '../../static/Awards.png'
import DiverseAbilities from '../../static/Diverse_Abilities.png'
import HumanitarianAid from '../../static/Humanitarian_Aid.png'
import Immigration from '../../static/Immigration.png'
import Legal from '../../static/Legal.png'
import MentalHealth from '../../static/Mental_Health.png'
import PostSecondary from '../../static/Post_Secondary.png'
import Science from '../../static/Science.png'
import Shelter from '../../static/Shelter.png'
import Youth from '../../static/Youth.png'
import PovertyRelief from '../../static/Poverty_Relief.png'
import Education from '../../static/Education.png'
import Research from '../../static/Research.png'
import Religion from '../../static/Religion.png'
import HealthCare from '../../static/Health_Care.png'
import HumanRights from '../../static/Human_Rights.png'
import Community from '../../static/Community.png'
import Environment from '../../static/Environment.png'
import Agriculture from '../../static/Agriculture.png'
import Animals from '../../static/Animals.png'
import Arts from '../../static/Arts.png'
import PublicAmenities from '../../static/Public_Amenities.png'
import Foundations from '../../static/Foundations.png'
import Other from '../../static/Other.png'

export const CATEGORY_NAMES = [
  'Alternative Health',
  'Athletics',
  'Awards',
  'Diverse Abilities',
  'Humanitarian Aid',
  'Immigration',
  'Legal',
  'Mental Health',
  'Post Secondary',
  'Science',
  'Shelter',
  'Youth',
  'Poverty Relief',
  'Education',
  'Research',
  'Religion',
  'Health Care',
  'Human Rights',
  'Community',
  'Environment',
  'Agriculture',
  'Animals',
  'Arts',
  'Public Amenities',
  'Foundations',
  'Other',
]

const categoryStyles = {
  'Alternative Health': { image: AlternativeHealth },
  Athletics: { image: Athletics },
  Awards: { image: Awards },
  'Diverse Abilities': { image: DiverseAbilities },
  'Humanitarian Aid': { image: HumanitarianAid },
  Immigration: { image: Immigration },
  Legal: { image: Legal },
  'Mental Health': { image: MentalHealth },
  'Post Secondary': { image: PostSecondary },
  Science: { image: Science },
  Shelter: { image: Shelter },
  Youth: { image: Youth },
  'Poverty Relief': { image: PovertyRelief },
  Education: { image: Education },
  Research: { image: Research },
  Religion: { image: Religion },
  'Health Care': { image: HealthCare },
  'Human Rights': { image: HumanRights },
  Community: { image: Community },
  Environment: { image: Environment },
  Agriculture: { image: Agriculture },
  Animals: { image: Animals },
  Arts: { image: Arts },
  'Public Amenities': { image: PublicAmenities },
  Foundations: { image: Foundations },
  Other: { image: Other },
}

export function DefaultLogo(name) {
  const category = categoryStyles[name] ? name : 'Other'
  return categoryStyles[category].image
}

function formatCategoryName(name) {
  if (name.includes('&')) {
    return name.split('&').map((part, index, array) => (
      /* eslint-disable react/no-array-index-key */
      <div key={index}>
        {part.trim()}
        {index < array.length - 1 && (
          <>
            <br /> & <br />
          </>
        )}
      </div>
    ))
  }
  return name.split(' ').map((word, index, array) => (
    /* eslint-disable react/no-array-index-key */
    <div key={index}>
      {word}
      {index < array.length - 1 && <br />}
    </div>
  ))
}

export function CategoryChip({ name, text = true, color }) {
  const { image } = categoryStyles[name] || categoryStyles.Other

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mr: 1,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          bgcolor: color || '#64bee5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          m: '0 auto',
        }}
      >
        <Box
          component="img"
          src={image}
          alt={`${name} icon`}
          sx={{
            width: 100,
            height: 100,
            objectFit: 'contain',
            borderRadius: '50%',
          }}
        />
      </Box>
      {text && (
        <Typography
          sx={{
            mt: 1,
            fontSize: 14,
            fontWeight: 'bold',
            color: '#333',
          }}
        >
          {formatCategoryName(name)}
        </Typography>
      )}
    </Box>
  )
}
